var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.status, rounded: "sm" } },
    [
      _c(
        "b-row",
        { staticClass: "asc__modal-approveModal" },
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("h5", [_vm._v(_vm._s(_vm.$t("insert.rejectModal")))])
          ]),
          _vm._v(" "),
          _vm.modalItem
            ? _c(
                "b-col",
                {
                  staticClass: "asc__modal-approveModal-body",
                  attrs: { cols: "12" }
                },
                [
                  _c("p", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v(_vm._s(_vm.modalItem.CommercialTitle))
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.modalItem.Description1))])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "asc__modal-approveModal-footer",
              attrs: { cols: "12" }
            },
            [
              _c(
                "div",
                { staticClass: "w-100 text-right" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { type: "button", variant: "warning", size: "md" },
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("insert.cancel")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        id: "submitButton",
                        type: "button",
                        size: "md",
                        variant: "danger"
                      },
                      on: {
                        click: function($event) {
                          return _vm.submit()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("insert.rejectModal")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cd725c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cd725c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PotentialCustomerRejectModal.vue
// module id = null
// module chunks = 